import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import EnterprisePanel from "./EnterprisePanel";
import MappingBranchPage from "./MappingBranchPage";
import FormatsPage from "./FormatsPage";
import "./EnterprisesPage.css";

const tabs = [
    { key: "settings", label: "Настройки предприятий", path: "/enterprises/settings" },
    { key: "branches", label: "Маппинг филиалов", path: "/enterprises/branches" },
    { key: "formats", label: "Форматы", path: "/enterprises/formats" },
];

const getActiveTab = (pathname) => {
    if (pathname.includes("/branches")) {
        return "branches";
    }
    if (pathname.includes("/formats")) {
        return "formats";
    }
    return "settings";
};

const EnterprisesPage = ({ authUser }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const activeTab = getActiveTab(location.pathname);

    if (location.pathname === "/enterprises") {
        return <Navigate to="/enterprises/settings" replace />;
    }

    return (
        <div className="enterprises-page">
            <div className="ent-page" style={{ padding: "24px", maxWidth: "1440px", margin: "0 auto" }}>
                <section className="ent-card" style={{ padding: "20px 24px" }}>
                    <h1 style={{ margin: "0 0 6px", fontSize: "26px", letterSpacing: "-.02em" }}>Предприятия</h1>
                    <p style={{ margin: 0, color: "var(--ent-muted)", fontSize: "14px" }}>
                        Настройки предприятий, маппинг филиалов и форматы данных.
                    </p>
                </section>

                <div className="ent-subtabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            className={activeTab === tab.key ? "ent-subtab active" : "ent-subtab"}
                            onClick={() => navigate(tab.path)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {activeTab === "settings" && <EnterprisePanel authUser={authUser} embedded />}
                {activeTab === "branches" && <MappingBranchPage embedded />}
                {activeTab === "formats" && <FormatsPage embedded />}
            </div>
        </div>
    );
};

export default EnterprisesPage;
